import AgencyCard from 'modules/Agency/AgencyCard/AgencyCard'
import Sagas from 'modules/Agency/AgencyCard/saga'
import Reducer from 'modules/Agency/AgencyCard/reducer'

export default AgencyCard

export { Sagas, Reducer }
